import * as stylex from "@stylexjs/stylex";
import { forwardRef } from "react";

import type {
  HallowElement,
  HallowElementProps,
  WithAsChild,
  WithStylexArray,
} from "../../../../types";
import { determineElementFromAsChild } from "../../../../utils";

const hallowElement: HallowElement = "div";

const styles = stylex.create({
  determinedElement: {
    display: "flex",
  },
});

export type FlexProps = WithAsChild<
  WithStylexArray<HallowElementProps<typeof hallowElement>>
>;

export const Flex = forwardRef<any, FlexProps>(
  ({ asChild = false, children, styleXArray, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement
        ref={ref}
        {...props}
        {...stylex.props(styles.determinedElement, styleXArray)}
      >
        {children}
      </DeterminedElement>
    );
  },
);

Flex.displayName = "Flex";
